<template>
    <div>                
        <div class="form-group">
            <label for="contractualItemsPerson[contractual_item_id]"> {{ __('forms.MeritMatrixSession.contractual_item_id') }}</label>
            <select class="form-control" name="contractualItemsPerson[contractual_item_id]" :disabled="disabled_contractual_item == 1" v-model="contractual_item.id" @change="changeContractualItem()">
                <option value="">---</option>
                <option v-for="item in list_contractual_items" v-bind:key="item.id" :value="item.id"> {{ item.name }} </option>
            </select>          
            <input type="hidden" v-model="contractual_item.id" name="contractualItemsPerson[contractual_item_id]" v-if="disabled_contractual_item == 1">  
        </div>
        <div class="form-group" v-if="contractual_item !== undefined && contractual_item != null && contractual_item.use_select">            
            <label for="contractualItemsPerson[value]"> {{ __('forms.ContractualItemsPeople.value') }}</label>
            <select class="form-control" name="contractualItemsPerson[value]" v-model="contractual_value">
                <option v-for="possibile_value in contractual_item.contractual_item_values" v-bind:key="possibile_value.name" :value="possibile_value.name">{{ possibile_value.name }}</option>
            </select>
        </div>
        <div class="form-group" v-else>
            <label for="contractualItemsPerson[value]"> {{ __('forms.ContractualItemsPeople.value') }}</label>
            <input type="text" class="form-control" name="contractualItemsPerson[value]" v-model="contractual_value">
        </div>
    </div>
</template>

<script>
  export default {

    data () {
        return {            
            contractual_item: {
                id: null,
                name: ""
            },            
            list_contractual_items: [],
        }
    },
    methods: {
        isWithSelect(){

            for(let i = 0; i < this.list_contractual_items.length; i++) {
                if (this.list_contractual_items[i].id == this.contractual_item.id) {                                                             
                    const sortedArray = this.list_contractual_items[i].contractual_item_values;                                      
                    sortedArray.sort((a, b) => a.name.localeCompare(b.name));                    
                    this.contractual_item = Object.assign({}, this.list_contractual_items[i]);                    
                    this.contractual_item.contractual_item_values = sortedArray;
                }
            }    
        },
        changeContractualItem(){            
            this.isWithSelect();
        }
    },
    mounted() {     

        this.contractual_item.id = this.contractual_item_id;
        this.list_contractual_items = JSON.parse(this.contractual_items);
        this.isWithSelect();        
    },
    props: {
        contractual_item_id: {
            type: Number,
            required: false,
            default: null         
        },
        contractual_items: {
            type: String,
            required: false,
            default:null,
        },
        contractual_value: {
            type: String,
            required: false,
            default: null
        },
        disabled_contractual_item: {
            type: Number,
            required: false,
            default: 0
        }
    }

  }
</script>

<style>

</style>
